export function pageMetaDataMixin(ConcertAds) {
  /**
   * Provide the page & article metadata for Permutive's page-data event. Only relevant when the
   * `waitForPageMetaData` setting is enabled — in that mode ConcertAds holds the Permutive
   * page-data send until this is called, then uses the supplied `{ page, article }` as the source
   * of truth (full override; see PageMetaData / getPageData). When the setting is off this is a
   * no-op and the existing variable-derived data is sent as before.
   *
   * Available on the app instance from construction, so it is safe to call before or after
   * install(). The same call is also exposed on the pmcAdBridge plugin (window.pmcAdBridge), which
   * only exists after the bridge chunk loads — see {@link PmcAdBridge#setPageMetaData}.
   *
   * @param {{ page?: object, article?: object }} data
   */
  ConcertAds.prototype.setPageMetaData = function(data) {
    this.pageMetaData.set(data);
  };
}
